{
  "version": 1,
  "asset_id": "e663b46c-503f-4930-8d6b-4d09a3639f6c",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/e663b46c-503f-4930-8d6b-4d09a3639f6c/suspension-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/e663b46c-503f-4930-8d6b-4d09a3639f6c/suspension-card.webp",
  "original_filename": "suspension-card.webp",
  "size": 30584,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:27Z"
}
